import { MARKETS_ID } from "application/constants/app-constants";
import getCountry from "./getCountry";
import { find, keys } from "ramda";

export default function getMarket() {
  const country = getCountry();
  const countryKeys = keys(MARKETS_ID);
  const region = find((k) => k === country, countryKeys);
  if (region) return MARKETS_ID[region];

  return MARKETS_ID["gb"];
}
